var $ = require('jquery');
var matchHeight = require('jquery-match-height');

$(function() {
    addMediaBlocksClick();
});

$(window).on('resize', function() {
    if ( $(window).width() > 768 ) {
        $('.media-and-blocks__content').each((index, el)=>{

            $(el).matchHeight({remove: true});
            $(el).css('height', 'auto')

        });
        addMediaBlocksClick();
    } else {
        $('.media-and-blocks__content').off('click');
    }
})

function addMediaBlocksClick() {
    $('.media-and-blocks__content').each(function() {
        
        var parent = $(this).closest('.media-and-blocks');
        var visuals = parent.find('.media-and-blocks__visuals');
        var num = $(this).attr('data-content-num');
        var events = $._data(this, "events");
    
        if ( events == undefined || ( events !== undefined && events.click.length < 1 ) ) {
            $(this).on('click', {
                parent: parent, el: this, num: num, visuals: visuals,
            }, changeMediaBlock);
        }
    })
}

function changeMediaBlock(e) {
    var parent = e.data.parent, el = e.data.el, num = e.data.num, visuals = e.data.visuals;
    if ( $(el).hasClass("is-selected") ) return;
    parent.find('.media-and-blocks__content.is-selected').removeClass('is-selected');
    parent.find('.media-and-blocks__visual.active').addClass('fading-out').removeClass('active');
    $(el).addClass('is-selected');
    visuals.find('.media-and-blocks__visual[data-visual-num="'+num+'"]').addClass('active');

    setTimeout(function() {
        parent.find('.media-and-blocks__visual.fading-out').removeClass('fading-out');
    }, 500);
}